import React from "react";
import LegalLayout, { H2, P, UL, Strong } from "@/pages/LegalLayout";

const PrivacyPage = () => (
  <LegalLayout
    title="Política de Privacidade — Documento Express"
    subtitle="Última atualização: 25 de maio de 2026"
  >
    <P>
      A Documento Express valoriza a privacidade, a segurança das informações e
      a transparência no tratamento de dados pessoais de todos os usuários,
      clientes e visitantes de seu site e plataformas digitais.
    </P>
    <P>
      Esta Política de Privacidade explica como coletamos, utilizamos,
      armazenamos e protegemos seus dados, em conformidade com a Lei Geral de
      Proteção de Dados (LGPD – Lei nº 13.709/2018).
    </P>

    <H2>1. Quem somos</H2>
    <P>
      A Documento Express é uma empresa especializada em comunicação digital
      corporativa, automação de notificações e envio de documentos digitais por
      meio de canais como WhatsApp, SMS, RCS, E-mail e Voz.
    </P>
    <P>
      <Strong>Site oficial:</Strong> documentoexpress.io
    </P>

    <H2>2. Dados coletados</H2>
    <P>Podemos coletar as seguintes informações:</P>
    <P>
      <Strong>2.1 Dados fornecidos pelo usuário</Strong>
    </P>
    <UL>
      <li>Nome completo</li>
      <li>Empresa</li>
      <li>Cargo</li>
      <li>E-mail corporativo</li>
      <li>Número de telefone</li>
      <li>Informações enviadas em formulários de contato ou demonstração</li>
    </UL>
    <P>
      <Strong>2.2 Dados coletados automaticamente</Strong>
    </P>
    <UL>
      <li>Endereço IP</li>
      <li>Navegador e dispositivo utilizado</li>
      <li>Data e hora de acesso</li>
      <li>Páginas visitadas</li>
      <li>Cookies e tecnologias semelhantes</li>
      <li>Dados estatísticos de navegação</li>
    </UL>

    <H2>3. Finalidade do uso dos dados</H2>
    <P>Os dados poderão ser utilizados para:</P>
    <UL>
      <li>Entrar em contato com o usuário;</li>
      <li>Apresentar propostas comerciais;</li>
      <li>Fornecer suporte técnico;</li>
      <li>Melhorar a experiência de navegação;</li>
      <li>Enviar comunicações institucionais;</li>
      <li>Cumprir obrigações legais e regulatórias;</li>
      <li>Garantir segurança e prevenção a fraudes.</li>
    </UL>

    <H2>4. Compartilhamento de dados</H2>
    <P>A Documento Express não comercializa dados pessoais.</P>
    <P>Os dados poderão ser compartilhados apenas:</P>
    <UL>
      <li>
        com fornecedores tecnológicos e parceiros operacionais necessários para
        execução dos serviços;
      </li>
      <li>mediante obrigação legal;</li>
      <li>por determinação judicial ou autoridade competente.</li>
    </UL>
    <P>
      Todos os parceiros seguem padrões adequados de segurança e
      confidencialidade.
    </P>

    <H2>5. Cookies e tecnologias de rastreamento</H2>
    <P>Utilizamos cookies para:</P>
    <UL>
      <li>funcionamento adequado do site;</li>
      <li>métricas e estatísticas;</li>
      <li>melhoria de desempenho;</li>
      <li>personalização da experiência do usuário.</li>
    </UL>
    <P>
      O usuário pode desativar os cookies diretamente em seu navegador, porém
      algumas funcionalidades poderão ser impactadas.
    </P>

    <H2>6. Segurança das informações</H2>
    <P>
      Adotamos medidas técnicas e organizacionais adequadas para proteção dos
      dados pessoais contra:
    </P>
    <UL>
      <li>acessos não autorizados;</li>
      <li>vazamentos;</li>
      <li>destruição;</li>
      <li>alteração indevida;</li>
      <li>perda de informações.</li>
    </UL>
    <P>
      Utilizamos conexões seguras, criptografia e controles de acesso
      compatíveis com boas práticas de mercado.
    </P>

    <H2>7. Retenção dos dados</H2>
    <P>Os dados serão armazenados apenas pelo período necessário para:</P>
    <UL>
      <li>cumprimento das finalidades desta política;</li>
      <li>obrigações legais;</li>
      <li>exercício regular de direitos;</li>
      <li>auditorias e requisitos regulatórios.</li>
    </UL>

    <H2>8. Direitos do titular</H2>
    <P>Nos termos da LGPD, o usuário poderá solicitar:</P>
    <UL>
      <li>confirmação do tratamento;</li>
      <li>acesso aos dados;</li>
      <li>correção de informações;</li>
      <li>anonimização ou exclusão;</li>
      <li>portabilidade;</li>
      <li>revogação do consentimento.</li>
    </UL>
    <P>
      Solicitações relacionadas à privacidade, tratamento de dados pessoais ou
      exercício de direitos previstos na LGPD poderão ser realizadas através do
      e-mail oficial:
    </P>
    <P>
      <a
        href="mailto:dpo@documentoexpress.io"
        className="text-[#1dc7e9] hover:underline"
      >
        dpo@documentoexpress.io
      </a>
    </P>

    <H2>9. Links externos</H2>
    <P>
      O site poderá conter links para plataformas externas. A Documento Express
      não se responsabiliza pelas políticas de privacidade de terceiros.
    </P>

    <H2>10. Alterações desta política</H2>
    <P>
      Esta Política poderá ser atualizada periodicamente sem aviso prévio.
      Recomendamos a revisão frequente desta página.
    </P>
  </LegalLayout>
);

export default PrivacyPage;
